import React from 'react';
import { YStack } from 'smoothie';

import { MoneyMapperPanelScrollView } from './MoneyMapperPanelScrollView';
import { MoneyMapperSectionHeading } from './MoneyMapperSectionHeading';
import { MainIncomeSourcesCard } from './take-home-pay/MainIncomeSourcesCard';
import { MoneyMapperIncomeDetailsModal } from './take-home-pay/MoneyMapperIncomeDetailsModal';
import type { MoneyMapperTakeHomePaySectionProps } from './take-home-pay/MoneyMapperTakeHomePayTypes';
import { MonthlyTakehomeFooter } from './take-home-pay/MonthlyTakehomeFooter';
import { useMoneyMapperTakeHomePaySection } from './take-home-pay/useMoneyMapperTakeHomePaySection';

export type { MoneyMapperTakeHomePaySectionProps } from './take-home-pay/MoneyMapperTakeHomePayTypes';

export const MoneyMapperTakeHomePaySection = (
    props: MoneyMapperTakeHomePaySectionProps,
) => {
    const {
        membership,
        canMutateIncomes,
        isSaving,
        pickers,
        incomes,
        mutations,
        detailsModal,
        newIncomeRow,
        guideTotal,
    } = useMoneyMapperTakeHomePaySection(props);

    if (membership == null) {
        return null;
    }

    return (
        <YStack flex={1} minHeight={0}>
            <MoneyMapperPanelScrollView style={{ flex: 1, minHeight: 0 }}>
                <YStack gap={20}>
                    <MoneyMapperSectionHeading
                        title="Take-home pay"
                        subtitle="Salary, wages, or predictable income."
                        subtitleMarginBottom={12}
                    />

                    <MainIncomeSourcesCard
                        membership={membership}
                        incomes={incomes}
                        showNewIncomeRow={newIncomeRow.show}
                        onShowNewRow={() => {
                            newIncomeRow.setShow(true);
                        }}
                        onCancelNewRow={() => {
                            newIncomeRow.setShow(false);
                        }}
                        ownerOptions={pickers.ownerOptions}
                        ownerPickerItems={pickers.ownerPickerItems}
                        payCyclePickerItems={pickers.payCyclePickerItems}
                        incomeTypePickerItems={pickers.incomeTypePickerItems}
                        canMutateIncomes={canMutateIncomes}
                        isSaving={isSaving}
                        isSubmittingIncome={detailsModal.isSubmittingIncome}
                        onOpenIncomeDetails={detailsModal.setDetailsIncomeId}
                        upsertMembershipIncomeAsync={
                            mutations.upsertMembershipIncomeAsync
                        }
                        refetchMembershipAndSyncMoneyMap={
                            mutations.refetchMembershipAndSyncMoneyMap
                        }
                    />
                </YStack>
            </MoneyMapperPanelScrollView>

            <YStack flexShrink={0} paddingTop={12} paddingBottom={16}>
                <MonthlyTakehomeFooter
                    guideTotal={guideTotal}
                    isSaving={isSaving}
                />
            </YStack>

            <MoneyMapperIncomeDetailsModal
                isOpen={detailsModal.detailsIncomeId != null}
                title={detailsModal.detailsModalTitle}
                detailsIncome={detailsModal.detailsIncome}
                detailsModalDraft={detailsModal.detailsModalDraft}
                setDetailsModalDraft={detailsModal.setDetailsModalDraft}
                ownerPickerItems={pickers.ownerPickerItems}
                payCyclePickerItems={pickers.payCyclePickerItems}
                incomeTypePickerItems={pickers.incomeTypePickerItems}
                detailsModalDisabled={detailsModal.detailsModalDisabled}
                canMutateIncomes={canMutateIncomes}
                isSubmittingIncome={detailsModal.isSubmittingIncome}
                onClose={detailsModal.closeDetailsModal}
                onSave={detailsModal.handleSaveIncomeDetails}
                onDelete={detailsModal.handleDeleteIncome}
            />
        </YStack>
    );
};
